import { Button, Container, Header, Segment } from '@mairistem/composants';
import React from 'react';
import { useHistory } from 'react-router';
import { MODES_REGLEMENTS_LIBELLE } from '@/constants';
import { RegieContext } from '@/contexts';
import { baseUrlFront } from '@/routes';

const PrelevementDesactiveMessage = () => {
  const history = useHistory();
  const { selectedRegie } = React.useContext(RegieContext);

  const handleRedirectToConstitution = React.useCallback(() => {
    history.push(`${baseUrlFront}/constitution/${selectedRegie}`);
  }, [history, selectedRegie]);

  return (
    <Container fluid style={{ paddingTop: 100, alignItems: 'center' }}>
      <Segment
        basic
        textAlign="center"
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Header icon size="large" data-testid="prelevement-inactif-message">
          Gestion des prélèvements inactive
          <br />
          <br />
          <Header.Subheader>
            Cette régie n&apos;est pas paramétrée pour gérer l&apos;encaissement de factures
            prélevées.
            <br />
            <br />
            Pour autoriser le paiement par prélèvement bancaire, renseignez les informations du
            compte DFT
            <br />
            et sélectionnez le mode de règlement
            {' "'}
            {MODES_REGLEMENTS_LIBELLE.PRELEVEMENT}
            {'" '}
            dans la constitution de la régie.
            <br />
          </Header.Subheader>
        </Header>
        <br />
        <Button
          data-testid="redirect-to-constitution-button"
          onClick={handleRedirectToConstitution}
          className="domain-colored"
        >
          {/* <Icon name="exchange" /> */}
          Accéder à la constitution de la régie
        </Button>
      </Segment>
    </Container>
  );
};

export default PrelevementDesactiveMessage;
